import React from 'react';
import './Paginacion.css';

function calcularPaginas(actual, total) {
  if (total <= 1) return [1];
  const pages = [];
  for (let i = Math.max(2, actual - 2); i <= Math.min(total - 1, actual + 2); i++) {
    pages.push(i);
  }
  if (actual - 2 > 2) pages.unshift('...');
  if (actual + 2 < total - 1) pages.push('...');
  pages.unshift(1);
  if (total > 1) pages.push(total);
  return pages;
}

export default function Paginacion({ paginaActual, totalPaginas, onChange }) {
  if (totalPaginas <= 1) return null;
  const paginas = calcularPaginas(paginaActual, totalPaginas);

  return (
    <div className="pag-wrap">
      <button
        className="pag-btn"
        disabled={paginaActual === 1}
        onClick={() => onChange(paginaActual - 1)}
      >
        ‹
      </button>

      {paginas.map((p, i) =>
        p === '...' ? (
          <span key={`ellipsis-${i}`} className="pag-ellipsis">…</span>
        ) : (
          <button
            key={p}
            className={`pag-btn ${p === paginaActual ? 'pag-btn--activa' : ''}`}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        )
      )}

      <button
        className="pag-btn"
        disabled={paginaActual === totalPaginas}
        onClick={() => onChange(paginaActual + 1)}
      >
        ›
      </button>
    </div>
  );
}
